<template>
  <div class="messForm">
    <el-form ref="form" :model="form" label-width="100px" :rules="rules" v-if="ifForm == 1">
      <el-form-item label="库   名 :">
        <el-col :span="10">
          <el-form-item prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col class="line" :span="4">领域 :</el-col>
        <el-col :span="10">
          <el-form-item prop="domain">
            <el-select class="fieldSel" style="width:100%" v-model="form.domainCode" placeholder="请选择领域"
              @change="remoteMethod" prop="domain">
              <el-option v-for="(item, index) in domainList" :key="index" :label="item.dataDesc" :value="item.dataKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="语言对 :">
        <el-col :span="10">
          <template v-if="!standard">
            <el-select @change="getLangeObjectLeft(form.sourceLeft)" v-model="form.sourceLeft" placeholder="源语言">
              <el-option v-for="(item, index) in LangList" :key="index" :label="item.sourceLangName"
                :value="item.sourceLang" :disabled="item.status == 0 || item.sourceLangName === form.sourceRight ">
              </el-option>
            </el-select>
          </template>

          <el-popover v-if="standard" placement="bottom" title trigger="hover" v-model="visibleLef">
            <ul class="languageBox" :class="standard" :style="{'width': (80 + Math.floor(LangList.length / 13 + 1) * 110 + Math.floor(LangList.length / 13 - 1) * 40) + 'px'}">
              <template v-for="(item, index) in LangList">
                <button :key="index" @click="getSourceLeft(item)" :disabled="isChoiceSourceLanguage(item) " :style="
                   isChoiceSourceLanguage(item)  ? 'cursor: not-allowed;color: #C0C4CC' : ''
                  " style="padding:0 5px">
                  {{ item.sourceLangName }}
                </button>
              </template>
            </ul>
            <el-input slot="reference" v-model="form.sourceLeft" placeholder="请选择源语言" :suffix-icon="
                !visibleLef ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              " readonly="readonly"></el-input>
          </el-popover>
        </el-col>
        <el-col class="line" :span="4">
          <i class="icon-right" @click="switchover"></i>
        </el-col>
        <el-col :span="10">
          <template v-if="!standard">
            <el-select @change="getLangeObjectRight(form.sourceRight)" no-data-text="请先选择源语言" v-model="form.sourceRight"
              placeholder="目标语言">
              <el-option v-for="(item, index) in LangList2" :key="index" :label="item.targetLangName"
                :value="item.targetLang" :disabled="item.status == 0">
              </el-option>
            </el-select>
          </template>

          <el-popover v-if="standard" placement="bottom" title trigger="hover" v-model="visibleRig">
            <p v-show="!LangList2.length">请先选择源语言</p>
            <ul class="languageBox" :class="standard" v-show="LangList2.length" :style="{'width': (80 + Math.floor(LangList.length / 13 + 1) * 110 + Math.floor(LangList.length / 13 - 1) * 40) + 'px'}">
              <template v-for="(item, index) in LangList2">
                <button :key="index" @click="getSourceRight(item)" :disabled="item.status == 0" :style="
                    item.status == 0 ? 'cursor: not-allowed;color: #C0C4CC' : ''
                  " style="padding:0 5px">
                  {{ item.targetLangName }}
                </button>
              </template>
            </ul>
            <el-input slot="reference" placeholder="请选择目标语言" v-model="form.sourceRight" :suffix-icon="
                !visibleRig ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              " readonly="readonly"></el-input>
          </el-popover>
        </el-col>
      </el-form-item>
    </el-form>
    <div class="mesUpload">
      <el-upload class="upload-demo" action :http-request="uploadSectionFile" multiple drag :limit="20"
        :on-exceed="handleExceed" :file-list="fileArr" :before-upload="beforeUploadFile"
        :on-progress="uploadFileProcess" :on-success="handleFileSuccess" :on-change="uploadChange"
        :show-file-list="false" accept=".xls,.xlsx,.txt,.tmx,.tbx">
        <div class="uploadBox" v-if="fileArr.length ? false : true">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            上传{{ myTemplate }}、xlsx、txt文件,且单个文件50M以下
          </div>
        </div>
        <template>
          <el-table v-if="fileArr.length ? true : false" class="tabBox" :data="fileArr" style="width: 100%"
            height="100%">
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="名称" min-width="40" :show-overflow-tooltip="true"></el-table-column>

            <el-table-column label="上传状态" min-width="40">
              <template slot-scope="scope">
                <img :src="isSrc(scope.row)" alt />
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="40">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                  <i class="icon-delete" @click.stop="handleDelete(scope.$index, scope.row)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-upload>
    </div>
    <div class="mesTemplate">
      <span class="mesTemplateText">*点击图标下载模板</span>
      <!-- <img style="cursor:pointer;" src="../assets/imgs/memory/normal_tmx.png" alt />
      <img style="cursor:pointer;" src="../assets/imgs/memory/normal_txt.png" alt />-->
      <!-- <img style="cursor:pointer;" src="../assets/imgs/memory/normal_xlsx.png" alt />  -->
      <a :href="this.baseURL + '/api/v1/memory/exportMemoryTemp?type=tmx'" v-if="myTemplate == 'tmx'">
        <i class="tmx">
        </i>
        <span>tmx</span>
      </a>
      <a :href="this.baseURL + '/api/v1/term/exportTermTemp?type=tbx'" v-if="myTemplate == 'tbx'">
        <i class="tbx">
        </i>
        <span>tbx</span>
      </a>
      <a :href="this.baseURL + templateUrl + '?type=txt'">
        <i class="txt">
        </i>
        <span>txt</span>
      </a>
      <a :href="this.baseURL + templateUrl + '?type=xlsx'">
        <i class="xlsx">
        </i>
        <span>xlsx</span>
      </a>
      <!-- <i class="tmx" v-if="myTemplate=='tmx'" @click="getFlieTemplate('tmx')"></i>
      <a :href="templateUrl"><i class="txt" @click="getFlieTemplate('txt')"></i></a>
      
      <i class="xlsx" @click="getFlieTemplate('xlsx')"></i>-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "messForm",
  props: ["ifForm", "isCall", "tit"],
  data () {
    var name1 = (rule, value, callback) => {
      value = value.replace(
        /^(\s|\u00A0)+|(\s|\u00A0)+$/g,
        ""
      );
      var regEn = /[*<>|?:.\/[\]]/im;
      if (!value) {
        return callback(new Error("库名不能为空"));
      }
      if (value.length > 16) {
        return callback(new Error("请输入16个以内字符"));
      }
      if (regEn.test(value)) {
        return callback(new Error("名称不能包含特殊字符"));
      }
      callback();
    };
    var territory1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("领域不能为空"));
      }
      callback();
    };
    return {
      form: {
        name: "",
        sourceRight: "",
        sourceLeft: "",
        sourceLang: "", // 源语言编码
        targetLang: "", // 目标语言编码
        domainCode: "", // 领域编码
        domainName: "", // 领域名称
        langDesc: "", //语言对
        sentFileUrlList: []
      },
      rules: {
        // name:[ { required: true, message: '请输入活动名称', trigger: 'blur' },
        //     { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }],
        name: [{ validator: name1, trigger: "blur" }]
        // territory: [{ validator: territory1, trigger: "change" }]
      },
      fileArr: [],
      visibleLef: false,
      visibleRig: false,
      LangList: "",
      LangList2: "",
      domainList: "",
      imgSrc: require("../assets/imgs/memory/upload_failure.png"),
      succeedImgSrc: require("../assets/imgs/memory/upload_success.png"),
      myTemplate: "",
      fileUrl: "",
      obp: true,
      templateUrl: "",
      standard: true,
    };
  },
  components: {},
  watch: {
    isCall () {
      this.callFileArr();
    }
  },
  created () {

    if (process.env.VUE_APP_NAME !== "hospital") {
      if (process.env.VUE_APP_NAME !== "drill") {
        this.standard = "standard"
      } else {
        this.standard = false
      }
    } else {
      this.standard = false
    }
    if (process.env.VUE_APP_NAME === "nation") {
      this.standard = false
    }
    if (process.env.VUE_APP_HOSPITAL === "demo") {
      this.standard = false
    }
    this.getTemplate();
    // this.standard = 'hospital' === process.env.VUE_APP_NAME ? '' : 'standard'
    this.getLangList("1"); // 获取源语言
    // this.getLangList("2"); // 获取目标语言

    this.getDomainList();
  },
  mounted () {
    // this.form.sourceLang = "chn";
    // this.form.targetLang  = "eng"
  },
  methods: {
    // 是否可选
    isChoiceSourceLanguage (item) {
      if (item.sourceLangName == "中文" && this.form.sourceRight !== "" && this.form.sourceRight !== "中文") {
        return false
      }
      if (this.form.sourceRight !== "" && this.form.sourceRight !== "中文") {
        return true
      } else {
        return item.status == 0 || item.sourceLangName === this.form.sourceRight
      }
    },
    //选择源语言值后转换为对象 --- 源语言
    getLangeObjectLeft (v) {

      let that = this
      this.LangList.forEach(item => {
        if (item.sourceLang == v) {
          that.getSourceLeft(item)
        }
      });
    },
    //选择源语言值后转换为对象 --- 目标语言
    getLangeObjectRight (v) {
      let that = this
      this.LangList2.forEach(item => {
        if (item.targetLang == v) {
          that.getSourceRight(item)
        }
      });
    },
    // 切换语言
    switchover () {
      let sourceLeft = this.form.sourceLeft;
      let sourceLang = this.form.sourceLang;
      let targetLang = this.form.targetLang;
      let sourceRight = this.form.sourceRight;
      this.form.sourceLang = targetLang
      this.form.targetLang = sourceLang
      this.form.sourceLeft = sourceRight;
      this.form.sourceRight = sourceLeft;
      this.getLangList(2, this.form.sourceLang); // 获取语言对  目标语言
      this.form.langDesc = this.form.sourceLeft + ">" + this.form.sourceRight;
      this.$store.commit("setNewForm", this.form);
    },
    isSrc (row) {
      if (row.percentage === 100) {
        return this.succeedImgSrc;
      } else if (row.percentage === -1) {
        return this.imgSrc;
      } else {
        return require("../assets/imgs/memory/upload_Loading.gif");
      }
    },
    //
    getTemplate () {
      if (this.tit == "新建记忆库" || this.tit == "上传记忆库") {
        this.myTemplate = "tmx";
        this.templateUrl = "/api/v1/memory/exportMemoryTemp";
        this.fileUrl = "/api/v1/memory/checkFileContent";
      }
      if (this.tit == "新建术语库" || this.tit == "上传术语库") {
        this.myTemplate = "tbx";
        this.templateUrl = "/api/v1/term/exportTermTemp";
        this.fileUrl = "/api/v1/term/checkFileContent";
      }
    },
    // 文件上传
    uploadSectionFile (param) {
      if (!param.file.obp) {
        // this.obp = true;
        return;
      }
      // console.log(param.file, "/////////????// //");
      var that = this;
      var fileObj = param.file;
      //自定义文件上传
      // // console.log(param);
      var re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      var type = resultArr[2];
      var url = "/api/v1/file/getUploadSign";
      var code = localStorage.getItem("myCompanyCode");
      var params = { companyCode: code, fileType: "catlib" };
      this.catReq1Service(url, params).then(function (response) {
        if (!response.success) {
          return;
        }

        var data = response.result;
        that.host = data.host;
        var key = data.keyPrefix + "." + type;
        delete data.keyPrefix;
        delete data.host;
        that.formData = new FormData();
        that.formData.append("key", key);
        Object.keys(data).forEach(function (key) {
          that.formData.append(key, data[key]);
        });
        that.formData.append("file", fileObj);
        that.getFileHost(param);
      });
    },
    // 检测文件编码
    getFileContent (path, param) {
      var that = this;
      this.catReq1Service(this.fileUrl, {
        fileUrlList: [path]
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;

        if (data.status === 0) {
          that.$message.closeAll();
          that.$message({
            message: data.reason,
            type: "error"
          });
        }
        that.fileArr.forEach(item => {
          if (item.uid === param.file.uid) {
            if (data.status === 0) {
              item.percentage = -1;
            } else {
              that.form.sentFileUrlList.push(path);
            }
          }
        });
        // that.refresh++;
        // that.$store.commit("setFileList", that.fileArr);
        // that.fileArr = ary;
        // console.log(that.fileArr);
      });
    },
    //
    getFileHost (param) {
      var that = this;
      // alert(that.host)
      var FileController = that.host;

      var config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, that.formData, config)

        .then(function (response) {
          if (!response) {
            return;
          }
          // console.log(response.data.result);

          // that.fileArr.push(param.file)

          that.getFileContent(response.data.result.fileName, param);
          var data = response.data.result;

          // that.form.sentFileUrlList.push(data.fileName);
          // that.imgSrc = require("../assets/imgs/memory/upload _Success.png");
          that.form.langDesc =
            that.form.sourceLeft + ">" + that.form.sourceRight;
          that.$store.commit("setNewForm", that.form);

          // that.$store.state.newForm = that.form;
          // console.log(that.$store.state.newForm);
          that.$emit("getMessForm", that.fileArr);
        })
        .catch(function (error) {

          that.fileArr.forEach(item => {
            if (item.name == param.file.name) {
              item.percentage = -1;
            }
          });
          // that.$message({
          //   message: "网络出错!",
          //   type: "error"
          // });
        });
    },
    // 获取领域
    getDomainList () {
      var that = this;
      var params = {
        dataType: "trans_domain"
      };
      this.catReq1Service("/api/v1/common/queryOptionList", params).then(
        function (response) {
          if (!response.success) {
            return;
          }
          that.domainList = response.result;
        }
      );
    },
    // 选择语言对 左
    getSourceLeft (item) {
      var that = this;
      // console.log(item);
      // if (item.sourceLangDesc == that.form.sourceRight) {
      //   that.$message({
      //     message: "语言重复!",
      //     type: "error"
      //   });
      //   return;
      // }
      this.getLangList("2", item.sourceLang); // 获取语言对  目标语言
      that.form.sourceLeft = item.sourceLangName;
      that.form.sourceLang = item.sourceLang;
      that.form.langDesc = that.form.sourceLeft + ">" + that.form.sourceRight;
      this.visibleLef = false;
    },
    // 选择语言对 右
    getSourceRight (item) {
      var that = this;
      // console.log(item);
      if (item.targetLangDesc == that.form.sourceLeft) {
        that.$message({
          message: "名称重复!",
          type: "warning"
        });
        return;
      }
      // this.getLangList("1", item.targetLang); // 获取语言对  源语言
      that.form.sourceRight = item.targetLangName;
      that.form.targetLang = item.targetLang;
      that.form.langDesc = that.form.sourceLeft + ">" + that.form.sourceRight;
      this.visibleRig = false;
    },
    // 获取语言对
    getLangList (type, params) {
      var that = this;
      let obj = {
        type: type,
        [type === 1 ? "targetLang" : "sourceLang"]: params || ""
      };
      for (let propName in obj) {
        if (obj[propName] === "") {
          delete obj[propName];
        }
      }
      this.catReq1Service(`/api/v1/common/queryLangList`, obj).then(function (
        response
      ) {
        if (!response.success) {
          return;
        }
        if (type === "1") {
          that.LangList = response.result;
        } else {
          that.LangList2 = response.result;
        }
      });
    },
    // 领域select事件
    remoteMethod (query) {
      // console.log(query);
      let obj = {};
      obj = this.domainList.find(item => {
        return item.dataKey === query; //筛选出匹配数据
      });
      this.form.domainName = obj.dataDesc;
    },
    // 清空
    callFileArr () {
      // this.fileArr = [];
      // this.$store.commit("removeSentFileUrl");
      // this.form.sentFileUrlList = [];
      // console.log(this.$store.state.newForm, "that.$store.state.newForm");
    },
    onSubmit () {
      // console.log(ifForm, "submit!");
    },
    /// 超出文件限制提示
    handleExceed () {
      this.$message({
        message: "最多20个文件",
        type: "warning"
      });
    },
    uploadChange (event, file, fileList) {
      this.fileArr = file;
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile (file) {
      var that = this;
      let type = this.typeReg(file.name); // 拿到文件后缀
      that.form.langDesc = that.form.sourceLeft + ">" + that.form.sourceRight;

      // that.fileArr.forEach(item => {
      //   if (item.name == file.name) {
      //     // that.fileArr.pop();
      //     that.$message({
      //       message: "上传文件名称重复!",
      //       type: "warning"
      //     });
      //     this.obp = false;
      //     return;
      //   }
      // });
      file.obp = true;
      this.fileArr.slice(0, -1).forEach(item => {
        if (item.name == file.name) {
          this.fileArr.pop();
          this.$message({
            message: "上传文件名称重复!",
            type: "warning"
          });
          file.obp = false;
          return false;
        }
      });
      const isTXT = type === "txt";
      const isXLSX = type === "xlsx";
      const isTMX = type === that.myTemplate;
      // console.log(isTMX, "typetypetypetype");
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isTXT && !isXLSX && !isTMX) {
        this.$message.closeAll();
        that.$message({
          message: `只支持${that.myTemplate}/xlsx/txt格式上传哦!`,
          type: "warning"
        });
        // this.fileArr.pop();
        file.obp = false;
        return false;
      }
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          message: "不支持上传空文件",
          type: "warning"
        });
        return false;
      }
      if (!isLt50M) {
        this.$message.closeAll();
        that.$message({
          message: "上传文件大小不能超过 50MB!",
          type: "warning"
        });
        // this.fileArr.pop();
        file.obp = false;
        return false;
      }
      return (isTXT || isXLSX || isTMX) && isLt50M;
    },
    //文件上传成功的函数(用于文件上传成功之后的逻辑)
    handleFileSuccess (res, file, fileList) {
      // console.log(this.ifForm, "submit!");
      var that = this;
      // // console.log(fileList, "333333");
      // // console.log(file);
      // // console.log(res);
      // that.fileArr = fileList;
      // // console.log(that.fileArr);
      // that.$emit("getMessForm", that.fileArr);
      // that.fileArr.forEach((item, index) => {
      //   // item.progressFlag = false;
      //   if (item.status == "success") {
      //     item.successFlag = true;
      //   } else {
      //     item.successFlag = false;
      //   }
      // });
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess (event, file, fileList) {

      // if (event.percent == 100) {
      //   this.fileArr.push(file);
      // }

      fileList.forEach(item => {
        if (item.percentage == 100) {
        } else {
          // item.progressFlag = true;
          // console.log(item.percentage);
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
          // console.log(item.progressPercent);
        }
      });
    },

    // 删除文件
    handleDelete (index, rows) {
      var that = this;
      that.fileArr.splice(index, 1);
      that.form.sentFileUrlList.splice(index, 1);
      // console.log(this.$store.state.newForm, "that.$store.state.newForm");
      // that.$store.commit("removeNewForm", index);
      // console.log(that.$store.state.newForm, "that.$store.state.newForm");
      // // console.log(that.form,"that.$store.state.newForm")
    }
  }
};
</script>
<style lang="less" scoped>
.messForm {
  /deep/.el-form {
    text-align: center;
    position: relative;
    left: 6%;
  }

  margin: 0 53px;
  .icon-right {
    display: inline-block;
    width: 32px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    background: url("../assets/imgs/memory/switchover.png") no-repeat;
    background-position: center;
    top: 4px;
    position: relative;
  }
  .mesUpload {
    width: 42.1vw;
    height: 12.1vw;
    background: rgba(241, 241, 241, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    /deep/.el-table__row td {
      border-left: 1px transparent !important;
    }
    /deep/.el-table--enable-row-hover .el-table__body tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background: rgba(210, 210, 210, 1);
    }
    // .el-table__body tr:hover>td {
    //   background-color: rgba(210,210,210,1) !important;
    // }
    // /deep/ .el-table tbody tr:hover>td { background-color: red }
    .el-table {
      background: rgba(241, 241, 241, 1);

      .icon-delete {
        display: inline-block;
        width: 20px;
        height: 18px;
        background: url("../assets/imgs/memory/delete_normal.png") no-repeat;
        vertical-align: middle;
      }
      // .icon-delete:hover {
      //   background: url("../assets/imgs/memory/delete_hover.png") no-repeat;
      // }
      .icon-delete:active {
        background: url("../assets/imgs/memory/delete_press.png") no-repeat;
      }
    }
    /deep/.el-table td {
      border-bottom: 0px solid #ffff;
      text-align: center;
    }
    /deep/.el-table td:nth-child(2) {
      text-align: left;
    }
    /deep/.el-table th {
      background: rgba(241, 241, 241, 1);
      text-align: center;
    }
    /deep/.el-table th:nth-child(2) {
      text-align: left;
    }
    /deep/.el-table tr {
      background: rgba(241, 241, 241, 1);
    }
    /deep/.upload-demo {
      width: 42.1vw;
      height: 12.1vw;
    }
    /deep/.el-upload-dragger {
      width: 42.1vw;
      height: 12.1vw;
      background: rgba(241, 241, 241, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      border: 0px;
      // border-radius: 2px;
    }
  }
  .mesTemplate {
    margin: 0 auto;
    width: 42.1vw;
    margin-top: 10px;
    text-align: left;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    .mesTemplateText {
      position: relative;
      top: -22px;
    }
    a {
      display: inline-block;
      margin-left: 10px;
      width: 34px;
      text-align: center;
    }
    i {
      width: 20px;
      height: 26px;
      // vertical-align: middle;
      display: block;
      cursor: pointer;
      margin: 0 auto;
    }
    .tbx {
      background: url("../assets/imgs/memory/tbx.png") no-repeat;
    }
    .tmx {
      background: url("../assets/imgs/memory/tmx.png") no-repeat;
    }
    .txt {
      background: url("../assets/imgs/memory/txt.png") no-repeat;
    }
    .xlsx {
      background: url("../assets/imgs/memory/xlsx.png") no-repeat;
    }
    // .tmx:hover {
    //   background: url("../assets/imgs/memory/hover_tmx.png") no-repeat;
    // }
    // .txt:hover {
    //   background: url("../assets/imgs/memory/hover_txt.png") no-repeat;
    // }
    // .xlsx:hover {
    //   background: url("../assets/imgs/memory/hover_xlsx.png") no-repeat;
    // }
    // //  .tbx:hover {
    // //   background: url("../assets/imgs/memory/tbx_hover.png");
    // // }
    // .tbx:active {
    //   background: url("../assets/imgs/memory/tbx_press.png") no-repeat;
    // }
    // .tmx:active {
    //   background: url("../assets/imgs/memory/press_tmx.png") no-repeat;
    // }
    // .txt:active {
    //   background: url("../assets/imgs/memory/press_txt.png") no-repeat;
    // }
    // .xlsx:active {
    //   background: url("../assets/imgs/memory/press_xlsx.png") no-repeat;
    // }
  }
  /deep/.el-col-10 {
    width: 30.6667%;
  }
}
.languageBox {
  min-height: 50px;
  max-height: 390px;
  width: 450px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // .languageLi {
  //   background: rgba(225, 238, 254, 1);
  // }
  button {
    float: left !important;
    width: 140px;
    height: 30px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
    line-height: 30px;
    border-radius: 4px;
    text-align: left !important;
    background: white;
  }
  button:hover {
    background: rgba(231, 231, 231, 1);
  }
  button:active {
    background: rgba(210, 210, 210, 1);
  }
}
</style>
<style lang="less">
.messForm {
  .mesUpload {
    .el-table__body {
      border-collapse: separate !important;
      border-spacing: 0px 5px !important;
    }
  }
}
</style>
